import { TabProps } from "@/components/Tab";
import { ProductKind } from "@/web-client/api";
import { useMemo } from "react";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";

type ProductSearchGroup = {
  tabs: TabProps[];
};

const useProductSearchGroup = (
  kind: ProductKind,
  query: ProductSearchQueryParameter,
  isSearchingPosts: boolean,
): ProductSearchGroup => {
  // 建材検索から、写真検索に切り替える際にsortパラメーターが残ってしまうので、
  // sortパラメーターを削除したものを用意する
  const queryWithoutSort = useMemo(() => {
    const clone = { ...query };
    delete clone.sort;

    return clone;
  }, [query]);

  const tabs = useMemo(() => {
    return [
      {
        isCurrent: !isSearchingPosts,
        to: {
          pathname:
            kind === ProductKind.BUILDING_MATERIAL
              ? "/building_materials/product_variations/search"
              : "/interiors/product_variations/search",
          query,
        },
        label: kind === ProductKind.BUILDING_MATERIAL ? "建材" : "家具",
      },
      {
        isCurrent: isSearchingPosts,
        to: {
          pathname:
            kind === ProductKind.BUILDING_MATERIAL
              ? "/building_materials/posts/search"
              : "/interiors/posts/search",
          query: queryWithoutSort,
        },
        label: "写真",
      },
    ];
  }, [kind, query, queryWithoutSort, isSearchingPosts]);

  return { tabs };
};
export default useProductSearchGroup;
